/* import __COLOCATED_TEMPLATE__ from './item-category-filter.hbs.js'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { isNone, isEmpty, isPresent } from '@ember/utils';
import { computed, action } from '@ember/object';
import Component from '@ember/component';
import { inject as service } from '@ember/service';
// eslint-disable-next-line ember/no-mixins
import SearchFilterSupport from '@dashboard/junk-drawer/mixins/search-filter-support';
let ItemCategoryFilter = (_dec = computed('filteredCategories.[]', 'categories.[]'), _class = class ItemCategoryFilter extends Component.extend(SearchFilterSupport) {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _defineProperty(this, "searchFilterText", '');
    _defineProperty(this, "searchProperties", ['name']);
    // passed in
    _defineProperty(this, "categoryFilterLabel", null);
    _defineProperty(this, "categories", []);
    _defineProperty(this, "nextPageToken", '');
    _defineProperty(this, "selectedCategory", null);
  }
  get listCategories() {
    const filteredCategories = this.filteredCategories;
    if (!isNone(filteredCategories)) {
      return filteredCategories;
    } else {
      return this.categories;
    }
  }
  handleOnChange() {
    if (!isEmpty(this.searchFilterText)) {
      // Clear search term and filtering, reset back to original state
      this.set('searchFilterText', '');
      this.set('filteredCategories', null);
    }
    this.onChange?.(this.selectedCategory);
  }
  updateFilter() {
    const filterString = this.searchFilterText;
    if (isEmpty(filterString)) {
      this.set('filteredCategories', null);
      return;
    }
    if (isPresent(this.nextPageToken)) {
      // each search starts at page 0 so pass '' for the paginationToken
      this.store.query('category', {
        pageSize: 50,
        text: filterString
      }).then(categories => {
        if (this.searchFilterText === filterString) {
          this.set('filteredCategories', categories);
        }
      });
    } else {
      // if nextPageToken is empty it means we've loaded all the categories so we can do local search
      const filteredCategories = this.filterObjectsBySearch(this.categories, filterString);
      this.set('filteredCategories', filteredCategories);
    }
  }
  loadNextPage() {
    if (isNone(this.filteredCategories)) {
      const nextPageToken = this.nextPageToken;
      if (isPresent(nextPageToken)) {
        this.set('nextPageIsLoading', true);
        this.store.query('category', {
          paginationToken: nextPageToken,
          pageSize: 50
        }).then(categories => {
          this.categories.addObjects(categories.toArray());
          this.set('nextPageIsLoading', false);
          const nextPageToken = categories.meta?.nextPageToken || '';
          this.set('nextPageToken', nextPageToken);
        });
      }
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "listCategories", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "listCategories"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleOnChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleOnChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateFilter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadNextPage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadNextPage"), _class.prototype), _class);
export { ItemCategoryFilter as default };